import styled from 'styled-components';
import Colours from '/shared/styled/Colours';

export default styled.div`
  background: ${Colours.white};
  border-top: 1px solid ${Colours.greyLight8};
  border-bottom: 1px solid ${Colours.greyLight8};
  padding: 1.333333rem 0;

  img {
    display: inline-block;
  }
`;
